/**
 * DeliverySlaStatus
 * @author ftgibran
 */

export enum DeliverySlaStatus {
  NOT_INFORMED = 1,
  SLA_IN = 2,
  SLA_OUT = 3,
}
